import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./PropertyPostConfiguration.scss";
import clsx from "clsx";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import dayjs, { Dayjs } from "dayjs";
import toast from "react-hot-toast";
import { Modal } from "@mui/material";
import { PropertyApi } from "../../../../../utils/api/Property";
import { CommonEnums } from "../../../../../enums/common.enums";
import { CommonHelpers } from "../../../../../utils/helpers/common.helpers";
import CustomPageLoader from "../../../../../components/loaders/CustomPageLoader";
import FacebookWhiteIcon from "../../../../../components/icons/FacebookWhiteIcon";
import FacebookIcon from "../../../../../components/icons/FacebookIcon";
import InstagramWhiteIcon from "../../../../../components/icons/InstagramWhiteIcon";
import InstagramIcon from "../../../../../components/icons/InstagramIcon";
import GoogleBusinessWhiteIcon from "../../../../../components/icons/GoogleBusinessWhiteIcon";
import GoogleBusinessIcon from "../../../../../components/icons/GoogleBusinessIcon";
import LinkedInWhiteIcon from "../../../../../components/icons/LinkedInWhiteIcon";
import LinkedInIcon from "../../../../../components/icons/LinkedInIcon";
import XWhiteIcon from "../../../../../components/icons/XWhiteIcon";
import XIcon from "../../../../../components/icons/XIcon";
import TikTokWhiteIcon from "../../../../../components/icons/TikTokWhiteIcon";
import TikTokIcon from "../../../../../components/icons/TikTokIcon";
import LockIcon2 from "../../../../../components/icons/LockIcon2";
import YouTubeWhiteIcon from "../../../../../components/icons/YouTubeWhiteIcon";
import YouTubeIcon from "../../../../../components/icons/YouTubeIcon";
import {
  getAgentProfileImageUrl,
  getImageUrl,
} from "../../../../../utils/helpers/common";
import LeftArrowIcon from "../../../../../components/icons/LeftArrowIcon";
import RightArrowIcon from "../../../../../components/icons/RightArrowIcon";
import CustomizeImageIcon from "../../../../../components/icons/CustomizeImageIcon";
import EditCaptionIcon from "../../../../../components/icons/EditCaptionIcon";
import PreviewCircleIcon from "../../../../../components/icons/PreviewCircleIcon";
import DownloadIcon from "../../../../../components/icons/DownloadIcon";
import TrueIcon from "../../../../../components/icons/TrueIcon";
import PreviewModal from "../view/PreviewModal";
import PropertyPostSystemMenuIcon from "./PropertyPostSystemMenuIcon";
import PropertyPlatformPostMenuIcon from "./PropertyPlatformPostMenuIcon";
import FacebookColorIcon from "../../../../../components/icons/FacebookColorIcon";
import InstagramColorIcon from "../../../../../components/icons/InstagramColorIcon";
import GoogleBusinessColorIcon from "../../../../../components/icons/GoogleBusinessColorIcon";
import LinkedInColorIcon from "../../../../../components/icons/LinkedInColorIcon";
import { PostPreferencesApi } from "../../../../../utils/api/PostPreferences";
import PlatformIssueCard from "./PlatformIssueCard";

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const PropertyPostJourneyConfiguration = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { propertyPostId } = useParams<{ propertyPostId: string }>();
  const [propertyPost, setPropertyPost] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [activeTab, setActiveTab] = useState("Facebook");
  const [sameTextToggle, setSameTextToggle] = useState(false);
  const [postPreviewIndex, setPostPreviewIndex] = useState(0);
  const [postStoryPreviewIndex, setPostStoryPreviewIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isUpdateTemplateOpen, setIsUpdateTemplateOpen] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [processingModalOpen, setProcessingModalOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [localPostStatus, setLocalPostStatus] = useState<
    "draft" | "scheduled" | "published"
  >("draft");
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  const [date, setDate] = useState<string>("");
  const [timeTo, setTimeTo] = useState<string>("");
  const [publishedDateTime, setPublishedDateTime] = useState<Dayjs | null>(
    null,
  );
  const [scheduledDateTime, setScheduledDateTime] = useState<Dayjs | null>(
    null,
  );
  const [scheduleDate, setScheduleDate] = useState<Dayjs | null>(null);
  const [scheduleTime, setScheduleTime] = useState<Dayjs | null>(null);
  const [scheduleMode, setScheduleMode] = useState<"schedule" | "auto" | null>(
    null,
  );
  const [isEditingCaption, setIsEditingCaption] = useState(false);
  const [postCaption, setPostCaption] = useState("");
  const scheduleFormRef = useRef<HTMLDivElement | null>(null);
  const [scheduleDateTime, setScheduleDateTime] = useState<dayjs.Dayjs | null>(
    null,
  );
  const lockedTabs = ["TikTok", "YouTube"];
  const isLocked = (tab: string) => lockedTabs.includes(tab);
  const stageLabelFromUrl = searchParams.get("stage_label");
  const navigate = useNavigate();

  const [postNowModalOpen, setPostNowModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [cancelScheduleModalOpen, setCancelScheduleModalOpen] = useState(false);
  const [editScheduleModalOpen, setEditScheduleModalOpen] = useState(false);
  const [timelineDocs, setTimelineDocs] = useState<any[]>([]);
  const [timelineLoading, setTimelineLoading] = useState(false);
  const [isFloatingPublishOpen, setIsFloatingPublishOpen] = useState(true);
  type ConfirmAction = "cancel" | "restore" | "archive" | "unarchive";

  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchorEl);

  const [menuLoading, setMenuLoading] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState<ConfirmAction | null>(
    null,
  );

  const [savePostPreferences, setSavePostPreferences] = useState(false);
  const [postPreferencesModalOpen, setPostPreferencesModalOpen] =
    useState(false);

  const currentStatus = propertyPost?.post_status;
  const isCancelled = currentStatus === "cancelled";
  const isArchived = currentStatus === "archived";

  const [selectedPlatforms, setSelectedPlatforms] = useState<
    Record<string, boolean>
  >({
    Facebook: false,
    Instagram: false,
    google_business: false,
    LinkedIn: false,
    // "X.com": false,
    TikTok: false,
    YouTube: false,
  });

  type PlatformKey =
    | "facebook"
    | "instagram"
    | "google_business"
    | "linkedin"
    | "tiktok"
    | "youtube";

  const PLATFORM_LABEL: Record<PlatformKey, string> = {
    facebook: "Facebook",
    instagram: "Instagram",
    google_business: "Google",
    linkedin: "LinkedIn",
    tiktok: "TikTok",
    youtube: "YouTube",
  };

  const isFailed = (s?: string) => s === "failed" || s === "error";
  const isWarning = (s?: string) =>
    s === "processing" || s === "pending_for_social_media_upload";

  const normalizeMsg = (issue: any) => {
    if (!issue) return null;
    if (typeof issue === "string") return { title: issue, message: "" };
    return {
      title: issue?.title || issue?.reason || issue?.code || "",
      message: issue?.message || issue?.detail || issue?.description || "",
    };
  };

  type SocialPlatformKey =
    | "facebook"
    | "instagram"
    | "google_business"
    | "linkedin";

  const getPlatformKeyFromTab = (tab: string): SocialPlatformKey | null => {
    if (tab === "Facebook") return "facebook";
    if (tab === "Instagram") return "instagram";
    if (tab === "google_business") return "google_business";
    if (tab === "LinkedIn") return "linkedin";
    return null;
  };

  const [platformPostNowOpen, setPlatformPostNowOpen] = useState(false);
  const [platformScheduleOpen, setPlatformScheduleOpen] = useState(false);

  const [platformScheduleDate, setPlatformScheduleDate] =
    useState<Dayjs | null>(dayjs());
  const [platformScheduleTime, setPlatformScheduleTime] =
    useState<Dayjs | null>(dayjs());

  const activePlatformKey = getPlatformKeyFromTab(activeTab);
  const activePlatformLabel = activeTab;

  type SchedulePlatformKey =
    | "facebook"
    | "instagram"
    | "google_business"
    | "linkedin";

  const [sameScheduleAll, setSameScheduleAll] = useState(true);

  const SCHEDULE_PLATFORMS: Array<{
    key: SchedulePlatformKey;
    selectedKey: string;
    label: string;
    Icon: React.ComponentType<any>;
    supported?: boolean;
  }> = [
    {
      key: "facebook",
      selectedKey: "Facebook",
      label: "Facebook",
      Icon: FacebookColorIcon,
      supported: true,
    },
    {
      key: "instagram",
      selectedKey: "Instagram",
      label: "Instagram",
      Icon: InstagramColorIcon,
      supported: true,
    },
    {
      key: "google_business",
      selectedKey: "google_business",
      label: "Google Business",
      Icon: GoogleBusinessColorIcon,
      supported: true,
    },
    {
      key: "linkedin",
      selectedKey: "LinkedIn",
      label: "LinkedIn",
      Icon: LinkedInColorIcon,
      supported: true,
    },
  ];

  const [perPlatformSchedule, setPerPlatformSchedule] = useState<
    Record<SchedulePlatformKey, { date: Dayjs | null; time: Dayjs | null }>
  >({
    facebook: { date: dayjs(), time: dayjs() },
    instagram: { date: dayjs(), time: dayjs() },
    google_business: { date: dayjs(), time: dayjs() },
    linkedin: { date: dayjs(), time: dayjs() },
  });

  const getPlatformKeyFromSelectedLabel = (
    label: string,
  ): SchedulePlatformKey | null => {
    if (label === "Facebook") return "facebook";
    if (label === "Instagram") return "instagram";
    if (label === "google_business") return "google_business";
    if (label === "LinkedIn") return "linkedin";
    return null;
  };

  const togglePlatformSelected = async (platformLabel: string) => {
    if (isLocked(platformLabel)) return;
    if (!propertyPostId) return;

    const platformKey = getPlatformKeyFromSelectedLabel(platformLabel);
    if (!platformKey) return;

    const nextEnabled = !selectedPlatforms[platformLabel];

    setSelectedPlatforms((p) => ({
      ...p,
      [platformLabel]: nextEnabled,
    }));

    // try {
    //   await PropertyApi.updatePropertyPost(propertyPostId, {
    //     platform: platformKey,
    //     enabled: nextEnabled,
    //   });

    //   await fetchPost(true);
    //   await fetchTimeline();
    // } catch (e) {
    //   console.error(e);
    //   toast.error("Failed to update platform selection");

    //   setSelectedPlatforms((p) => ({
    //     ...p,
    //     [platformLabel]: !nextEnabled,
    //   }));
    // }
  };

  const combineDayjsDateTime = (d: Dayjs | null, t: Dayjs | null) => {
    if (!d || !t) return null;
    const combined = d
      .hour(t.hour())
      .minute(t.minute())
      .second(0)
      .millisecond(0);
    return combined.isValid() ? combined : null;
  };

  const getSelectedSupportedPlatforms = (): SchedulePlatformKey[] => {
    const platforms: SchedulePlatformKey[] = [];

    if (selectedPlatforms["Facebook"]) platforms.push("facebook");
    if (selectedPlatforms["Instagram"]) platforms.push("instagram");
    if (selectedPlatforms["google_business"]) platforms.push("google_business");
    if (selectedPlatforms["LinkedIn"]) platforms.push("linkedin");

    return platforms;
  };

  const openMenu = (e: React.MouseEvent<HTMLElement>) =>
    setMenuAnchorEl(e.currentTarget);
  const closeMenu = () => setMenuAnchorEl(null);

  const openConfirm = (action: ConfirmAction) => {
    closeMenu();
    setConfirmAction(action);
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    if (menuLoading) return;
    setConfirmOpen(false);
    setConfirmAction(null);
  };

  const tabs = [
    "Facebook",
    "Instagram",
    "Google Business",
    "Linkedin",
    "Youtube",
  ];

  const images = [
    "/images/property-inside.jpg",
    "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg",
    "https://as2.ftcdn.net/jpg/02/61/89/29/1000_F_261892957_6jyBXvEgM79iYr1eEiJKCosnVPJdvHHr.jpg",
  ];

  const isScheduleUiOpenRef = useRef(false);

  useEffect(() => {
    isScheduleUiOpenRef.current = scheduleModalOpen || editScheduleModalOpen;
  }, [scheduleModalOpen, editScheduleModalOpen]);

  const fetchPost = useCallback(
    async (isInitial = false) => {
      if (!propertyPostId) return;

      try {
        if (isInitial) setLoading(true);

        const res = await PropertyApi.getPropertyPostById(propertyPostId);
        if (res?.data?.success) {
          const updatedPost = res.data.data;

          setPropertyPost(updatedPost);

          if (updatedPost.schedule_datetime && !isScheduleUiOpenRef.current) {
            const dt = dayjs(updatedPost.schedule_datetime);
            if (dt.isValid()) {
              setScheduleDateTime(dt);
              setScheduleDate(dt);
              setScheduleTime(dt);
            }
          }

          const updatedStatuses = [
            updatedPost?.image_post_design_activity_ref?.design_status,
            updatedPost?.story_post_design_activity_ref?.design_status,
            updatedPost?.video_post_design_activity_ref?.design_status,
            updatedPost?.reel_post_design_activity_ref?.design_status,
          ];

          const shouldPoll =
            updatedStatuses.includes("processing") ||
            !updatedStatuses.includes("pending_for_social_media_upload");

          if (shouldPoll && !intervalRef.current) {
            // intervalRef.current = setInterval(() => fetchPost(false), 3000);
          } else if (!shouldPoll && intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        }
      } catch (err) {
        console.error("Failed to fetch property post:", err);
        if (isInitial) toast.error("Unable to load property post");
      } finally {
        if (isInitial) setLoading(false);
      }
    },
    [propertyPostId],
  );

  const fetchTimeline = useCallback(async () => {
    if (!propertyPostId) return;

    setTimelineLoading(true);
    try {
      const res = await PropertyApi.getPropertyPostTimeline(propertyPostId, {
        page: 1,
        limit: 50,
        created_at: "desc",
      });

      const docs = res?.data?.data?.docs || res?.data?.data?.data?.docs;
      setTimelineDocs(Array.isArray(docs) ? docs : []);
    } catch (e) {
      console.error(e);
      setTimelineDocs([]);
    } finally {
      setTimelineLoading(false);
    }
  }, [propertyPostId]);

  useEffect(() => {
    fetchTimeline();
  }, [fetchTimeline]);

  useEffect(() => {
    if (!propertyPostId) return;
    fetchPost(true);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [propertyPostId, fetchPost]);

  const issues = useMemo(() => {
    const post = propertyPost;
    if (!post) return [];

    const keys: PlatformKey[] = [
      "facebook",
      "instagram",
      "google_business",
      "linkedin",
      "tiktok",
      "youtube",
    ];

    return keys
      .map((k) => {
        const p = post?.[k];
        if (!p?.enabled) return null; // ← null return ho sakta hai

        const label = PLATFORM_LABEL[k];

        const issueRaw = p?.error || p?.warning;
        if (!issueRaw) return null; // ← null return ho sakta hai

        const parsed = normalizeMsg(issueRaw);
        const isError = !!p?.error;
        const variant: "error" | "warning" = isError ? "error" : "warning";

        const heading =
          variant === "error"
            ? `${label} post failed`
            : `${label}: Post update`;

        return {
          key: k,
          variant,
          heading,
          title: parsed?.title || undefined,
          message: parsed?.message || undefined,
        };
      })
      .filter((item): item is NonNullable<typeof item> => item !== null); // ← Type guard
  }, [propertyPost]);

  useEffect(() => {
    if (!scheduleModalOpen) return;

    const base = propertyPost?.schedule_datetime
      ? dayjs(propertyPost.schedule_datetime)
      : dayjs();

    setScheduleDate(base);
    setScheduleTime(base);

    setPerPlatformSchedule((prev) => ({
      ...prev,
      facebook: { date: base, time: base },
      instagram: { date: base, time: base },
      google_business: { date: base, time: base },
      linkedin: { date: base, time: base },
    }));
  }, [scheduleModalOpen, propertyPost]);

  useEffect(() => {
    if (!propertyPost) return;

    setSelectedPlatforms((prev) => ({
      ...prev,
      Facebook: propertyPost?.facebook?.enabled ?? prev.Facebook,
      Instagram: propertyPost?.instagram?.enabled ?? prev.Instagram,
      google_business:
        propertyPost?.google_business?.enabled ?? prev["google_business"],
      LinkedIn: propertyPost?.linkedin?.enabled ?? prev["LinkedIn"],
    }));
  }, [propertyPost]);

  useEffect(() => {
    if (propertyPost?.schedule_datetime) {
      const scheduleDt = dayjs(propertyPost.schedule_datetime);
      const now = dayjs();

      if (scheduleDt.isBefore(now)) {
        setLocalPostStatus("published");
        setPublishedDateTime(scheduleDt);
        setScheduledDateTime(null);
        setShowScheduleForm(false);
      } else {
        setLocalPostStatus("scheduled");
        setScheduledDateTime(scheduleDt);
        setPublishedDateTime(null);
        setShowScheduleForm(false);
      }
    } else {
      setLocalPostStatus("draft");
      setPublishedDateTime(null);
      setScheduledDateTime(null);
    }
  }, [propertyPost]);

  const handleOpenEditSchedule = () => {
    const dt = propertyPost?.schedule_datetime
      ? dayjs(propertyPost.schedule_datetime)
      : dayjs();

    if (dt.isValid()) {
      setScheduleDate(dt);
      setScheduleTime(dt);
    }
    setEditScheduleModalOpen(true);
  };

  useEffect(() => {
    if (propertyPost) {
      const initialText = propertyPost?.post_text?.generated_caption || "";
      setPostCaption(initialText);
    }
  }, [propertyPost]);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const fullText = `Featuring: 5 🛌  Bedrooms | 5 🛀  Bathrooms | 2 🚗 Car Spaces... more
💸 Price Range: $1,675,000 - $1,842,000
Discover a lifestyle that's more than extraordinary – it's truly exceptional. Nestled in the heart of Berwick Waters, this stunning property at 6 Rockbank Road offers everything you need to live like a star.
Don't miss the chance to experience the allure of celebrity living. Come and see what makes 6 Rockbank Road the ultimate address for those who demand the best.
Your dream lifestyle awaits!
📸 Explore More: https://www.realestate.com.au/property-house-vic-clyde...
For more information or to book a viewing,

Learn more at BrandFeeds [Brand feeds Link for this property here]

Contact
Sukhdeep Singh 📲 0420 879 430
Mohan Singh 📲 0426 250 579
#celebrityliving #dreamhome #luxurylifestyle #clydenorthrealestate 
#berwickwaters #melbournerealestate #homesforsale #luxuryhomes 
#realestategoals #propertyforsale #dreamliving #familyhome 
#investmentproperty`;

  const shortText = `Experience Celebrity Living at 📍 6 Rockbank Road, Clyde North Spaces...`;

  const handleSaveCaption = async () => {
    setIsEditingCaption(false);

    setPropertyPost((prev: any) => ({
      ...prev,
      post_text: {
        ...prev?.post_text,
        generated_caption: postCaption,
        last_edited_at: new Date().toISOString(),
      },
    }));

    toast.success("Caption updated successfully");
  };

  const handleCancelCaption = () => {
    setIsEditingCaption(false);
    if (propertyPost?.post_text) {
      setPostCaption(propertyPost.post_text);
    }
  };

  const getShortText = (text: string) => {
    if (!text) return "";
    const limit = 100;
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const formatPostType = (slug: string) => {
    if (!slug) return "";
    return slug
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const renderDesignImage = (item: any) => {
    const designActivityRef = item?._id ? item : null;

    const assetUrlRaw = designActivityRef?.design_task_id?.output_image_path;
    const postType =
      designActivityRef?.design_post_type || item?.design_post_type;
    const designTaskStatus = designActivityRef?.design_task_id?.task_status;

    const isLoading = designTaskStatus === CommonEnums.taskStatus.queued;
    const isErrored = designTaskStatus === CommonEnums.taskStatus.errored;

    const assetUrl = assetUrlRaw
      ? CommonHelpers.getImageUrlFromImageTool({ path: assetUrlRaw })
      : null;

    // --- Error State ---
    if (isErrored) {
      return (
        <div className="activity-image-section image-placeholder-container">
          <img
            src="/images/image-video-generation-error-fallback-image-for-card.png"
            alt="Error Preview"
            className="activity-thumbnail placeholder-image"
          />
        </div>
      );
    }

    if (isLoading) {
      const fallback =
        postType === CommonEnums.postType.video_post.key
          ? "/images/square-fallback-image-for-video-preview.png"
          : "/images/square-fallback-image-for-image-preview.png";

      return (
        <div className="activity-image-section image-placeholder-container">
          <img
            src={fallback}
            alt="Loading Preview"
            className="activity-thumbnail placeholder-image"
          />
          <div className="loader-container">
            <CustomPageLoader className="activity-card-loader" />
            <p className="processing-text font-poppins-400">Processing...</p>
          </div>
        </div>
      );
    }

    if (postType === CommonEnums.postType.story_post.key) {
      return (
        <div className="activity-image-section story-post-image-container">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Story Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    if (postType === CommonEnums.postType.video_post.key) {
      return (
        <div className="activity-image-section video-placeholder-collection">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Video Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    if (postType === CommonEnums.postType.reel_post.key) {
      return (
        <div className="activity-image-section reel-placeholder-collection">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Reel Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    return (
      <div className="activity-image-section">
        <img
          src={
            assetUrl ||
            "/images/image-video-generation-error-fallback-image-for-card.png"
          }
          alt="Image Preview"
          className="activity-thumbnail"
          onError={(e: any) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src =
              "/images/image-video-generation-error-fallback-image-for-card.png";
          }}
        />
      </div>
    );
  };

  const getSelectedTemplateId = () => {
    if (!propertyPost) return "";

    switch (propertyPost.post_type) {
      case CommonEnums.postTypes.image_post:
        return (
          propertyPost?.image_post_design_activity_ref?.design_template_id ||
          propertyPost?.template_id ||
          ""
        );
      case CommonEnums.postTypes.story_post:
        return (
          propertyPost?.story_post_design_activity_ref?.design_template_id ||
          propertyPost?.template_id ||
          ""
        );
      case CommonEnums.postTypes.video_post:
        return (
          propertyPost?.video_post_design_activity_ref?.design_template_id ||
          propertyPost?.template_id ||
          ""
        );
      case CommonEnums.postTypes.reel_post:
        return (
          propertyPost?.reel_post_design_activity_ref?.design_template_id ||
          propertyPost?.template_id ||
          ""
        );
      default:
        return propertyPost?.template_id || "";
    }
  };

  const designStatuses = [
    propertyPost?.image_post_design_activity_ref?.design_status,
    propertyPost?.story_post_design_activity_ref?.design_status,
    propertyPost?.video_post_design_activity_ref?.design_status,
    propertyPost?.reel_post_design_activity_ref?.design_status,
  ].filter(Boolean);

  const hasPendingForUpload = designStatuses.includes(
    "pending_for_social_media_upload",
  );

  const formattedSchedule = propertyPost?.schedule_datetime
    ? dayjs(propertyPost?.schedule_datetime).format(
        "MMMM DD, YYYY [at] hh:mm A",
      )
    : "-";

  // const handlePostNow = async (
  //   propertyPostId: string,
  //   designActivityRef: any,
  //   caption: string,
  // ) => {
  //   if (!propertyPostId || !designActivityRef) {
  //     toast.error("Property post or design not selected.");
  //     return;
  //   }

  //   setUpdating(true);

  //   try {
  //     const currentDateTime = dayjs().toISOString();

  //     const res = await PropertyApi.updatePropertyPost(propertyPostId, {
  //       schedule_type: "post_now",
  //       schedule_datetime: currentDateTime,
  //     });

  //     if (res?.data?.success) {
  //       toast.success("Post updated in database successfully!");
  //       setPropertyPost((prev: any) => ({ ...prev, ...res.data.data }));
  //       await fetchTimeline();
  //     } else {
  //       toast.error(res?.data?.message || "Failed to update property post");
  //       return;
  //     }

  //     const designTaskStatus = designActivityRef?.design_task_id?.task_status;
  //     const assetUrlRaw = designActivityRef?.design_task_id?.output_image_path;

  //     if (designTaskStatus === CommonEnums.taskStatus.errored) {
  //       toast.error("Design task errored. Cannot post this item.");
  //       return;
  //     }

  //     if (!assetUrlRaw) {
  //       toast.error("No processed image/video found to post.");
  //       return;
  //     }

  //     const assetUrl = CommonHelpers.getImageUrlFromImageTool({
  //       path: assetUrlRaw,
  //     });

  //     try {
  //       await SocialMediaApi.postFacebookImage({
  //         imageUrl: assetUrl,
  //         caption,
  //         scheduleType: "post_now",
  //       });
  //       toast.success("Post published to Facebook successfully!");
  //     } catch (fbError: any) {
  //       console.error("Error posting to Facebook:", fbError);
  //       toast.error(
  //         fbError?.response?.data?.message ||
  //           "Post updated in DB but failed to publish on Facebook",
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error publishing now:", error);
  //     toast.error("Something went wrong while publishing");
  //   } finally {
  //     setUpdating(false);
  //   }
  // };

  useEffect(() => {
    if (!propertyPost) return;

    const ps = propertyPost?.publishing_schedule;

    if (ps === "different_for_each_platform") {
      setSameScheduleAll(false);
    } else if (ps === "same_for_all_platforms") {
      setSameScheduleAll(true);
    }
  }, [propertyPost]);

  const openPlatformPostNow = () => {
    if (!activePlatformKey) {
      toast.error("This platform is not supported yet");
      return;
    }
    if (!selectedPlatforms[activeTab]) {
      toast.error(`${activePlatformLabel} is not selected`);
      return;
    }
    setPlatformPostNowOpen(true);
  };

  const openPlatformSchedule = () => {
    if (!activePlatformKey) {
      toast.error("This platform is not supported yet");
      return;
    }
    if (!selectedPlatforms[activeTab]) {
      toast.error(`${activePlatformLabel} is not selected`);
      return;
    }

    const dtRaw = propertyPost?.[activePlatformKey]?.schedule_datetime;
    const dt = dtRaw ? dayjs(dtRaw) : dayjs();

    setPlatformScheduleDate(dt);
    setPlatformScheduleTime(dt);
    setPlatformScheduleOpen(true);
  };

  const handlePlatformPostNow = async () => {
    if (!propertyPostId || updating) return;
    if (!activePlatformKey) return;

    setUpdating(true);
    try {
      const payload = {
        platform: activePlatformKey,
        schedule_type: "post_now",
        // schedule_datetime optional (backend sets now if missing)
      };

      const res = await PropertyApi.updatePropertyPost(propertyPostId, payload);

      if (res?.data?.success) {
        toast.success(`Posting to ${activePlatformLabel} started`);
        await fetchPost(true);
        await fetchTimeline();
      } else {
        toast.error(res?.data?.message || "Failed to publish now");
      }
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong");
    } finally {
      setUpdating(false);
    }
  };

  const handlePlatformSchedule = async () => {
    if (!propertyPostId || updating) return;
    if (!activePlatformKey) return;

    if (!platformScheduleDate || !platformScheduleTime) {
      toast.error("Please select both date and time");
      return;
    }

    const combined = platformScheduleDate
      .hour(platformScheduleTime.hour())
      .minute(platformScheduleTime.minute())
      .second(0)
      .millisecond(0);

    if (!combined.isValid()) {
      toast.error("Invalid date/time");
      return;
    }

    setUpdating(true);
    try {
      const payload = {
        platform: activePlatformKey,
        schedule_type: "schedule_datetime",
        schedule_datetime: combined.toISOString(),
      };

      const res = await PropertyApi.updatePropertyPost(propertyPostId, payload);

      if (res?.data?.success) {
        toast.success(`${activePlatformLabel} scheduled`);
        setPlatformScheduleOpen(false);
        await fetchPost(true);
        await fetchTimeline();
      } else {
        toast.error(res?.data?.message || "Failed to schedule");
      }
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong");
    } finally {
      setUpdating(false);
    }
  };

  const handlePlatformCancelSchedule = async () => {
    if (!propertyPostId || updating) return;
    if (!activePlatformKey) return;

    setUpdating(true);
    try {
      const payload = {
        platform: activePlatformKey,
        schedule_type: null,
        schedule_datetime: null,
      };

      const res = await PropertyApi.updatePropertyPost(propertyPostId, payload);

      if (res?.data?.success) {
        toast.success(`${activePlatformLabel} schedule cancelled`);
        await fetchPost(true);
        await fetchTimeline();
      } else {
        toast.error(res?.data?.message || "Failed to cancel schedule");
      }
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong");
    } finally {
      setUpdating(false);
    }
  };

  const handlePostNow = async () => {
    if (!propertyPostId || updating) return;

    const selected = getSelectedSupportedPlatforms();
    if (selected.length === 0) {
      toast.error("Please select at least one platform.");
      return;
    }

    setUpdating(true);
    try {
      const nowIso = dayjs().toISOString();

      const results = await Promise.allSettled(
        selected.map((platform) =>
          PropertyApi.updatePropertyPost(propertyPostId, {
            platform,
            schedule_type: "post_now",
            schedule_datetime: nowIso,
          }),
        ),
      );

      const anyFailed = results.some(
        (r) =>
          r.status === "rejected" ||
          (r.status === "fulfilled" && !r.value?.data?.success),
      );

      if (anyFailed) {
        toast.error("Some platforms failed to publish. Please try again.");
      } else {
        toast.success("Posting started for selected platforms!");
      }

      await fetchPost(true);
      await fetchTimeline();
    } catch (error: any) {
      console.error(error);
      toast.error(error?.message || "Something went wrong while posting now");
    } finally {
      setUpdating(false);
    }
  };

  const handleConfirmCancelSchedule = async () => {
    if (!propertyPostId || updating) return;

    setUpdating(true);
    try {
      const res = await PropertyApi.updatePropertyPost(propertyPostId, {
        schedule_type: null,
        schedule_datetime: null,
      });

      if (res?.data?.success) {
        toast.success("Schedule cancelled");
        setPropertyPost((prev: any) => ({
          ...prev,
          schedule_type: null,
          schedule_datetime: null,
        }));
        setCancelScheduleModalOpen(false);
        await fetchTimeline();
      } else {
        toast.error(res?.data?.message || "Failed to cancel schedule");
      }
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong");
    } finally {
      setUpdating(false);
    }
  };

  type PublishingSchedule =
    | "same_for_all_platforms"
    | "different_for_each_platform";

  const getPublishingScheduleValue = (): PublishingSchedule =>
    sameScheduleAll ? "same_for_all_platforms" : "different_for_each_platform";

  const handleConfirmSchedule = async () => {
    if (!propertyPostId || updating) return;

    setUpdating(true);

    const platformLabel = (p: SchedulePlatformKey) => {
      switch (p) {
        case "facebook":
          return "Facebook";
        case "instagram":
          return "Instagram";
        case "google_business":
          return "Google Business";
        case "linkedin":
          return "LinkedIn";
        default:
          return p;
      }
    };

    try {
      const selected = getSelectedSupportedPlatforms(); // SchedulePlatformKey[]

      if (selected.length === 0) {
        toast.error("Please select at least one platform to schedule.");
        return;
      }

      if (sameScheduleAll) {
        if (!scheduleDate || !scheduleTime) {
          toast.error("Please select both date and time to schedule.");
          return;
        }

        const combinedDateTime = combineDayjsDateTime(
          scheduleDate,
          scheduleTime,
        );
        if (!combinedDateTime) {
          toast.error("Invalid date/time selected.");
          return;
        }

        const payload = {
          schedule_datetime: combinedDateTime.toISOString(),
          schedule_type: "schedule_datetime",
          publishing_schedule: getPublishingScheduleValue(),
        };

        const res = await PropertyApi.updatePropertyPost(
          propertyPostId,
          payload,
        );

        if (res?.data?.success) {
          toast.success("Post scheduled successfully!");
          setScheduleModalOpen(false);
          setEditScheduleModalOpen(false);
          await fetchPost(true);
          await fetchTimeline();
        } else {
          toast.error(res?.data?.message || "Failed to schedule post");
        }

        return;
      }

      const calls = selected.map(async (platform) => {
        const v = perPlatformSchedule[platform];

        const dt = combineDayjsDateTime(v?.date || null, v?.time || null);
        if (!dt) {
          throw new Error(
            `Please select valid date/time for ${platformLabel(platform)}.`,
          );
        }

        return PropertyApi.updatePropertyPost(propertyPostId, {
          platform,
          schedule_type: "schedule_datetime",
          schedule_datetime: dt.toISOString(),
          publishing_schedule: getPublishingScheduleValue(),
        });
      });

      const results = await Promise.allSettled(calls);

      const anyFailed = results.some(
        (r) =>
          r.status === "rejected" ||
          (r.status === "fulfilled" && !r.value?.data?.success),
      );

      if (anyFailed) {
        toast.error("Some platforms failed to schedule. Please try again.");
      } else {
        toast.success("Scheduled successfully!");
        setScheduleModalOpen(false);
        setEditScheduleModalOpen(false);
      }

      await fetchPost(true);
      await fetchTimeline();
    } catch (error: any) {
      console.error("Error scheduling post:", error);
      toast.error(error?.message || "Something went wrong while scheduling");
    } finally {
      setUpdating(false);
    }
  };

  const handleShowForm = (mode: "schedule" | "auto") => {
    setScheduleMode(mode);
    setTimeout(() => {
      scheduleFormRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const previewImages = [
    "https://res.cloudinary.com/dxnjxjtwh/image/upload/v1772794870/Frame_1261156603_urera9.png",
    "https://res.cloudinary.com/dxnjxjtwh/image/upload/v1772880839/50e4b8a38cedf2a298e8727b499c7b1a0d3db07a_kuwymx.jpg",
    "https://res.cloudinary.com/dxnjxjtwh/image/upload/v1772881727/9f10bdd6592a13aee11ea1a151bc0ea6bdd6c3c2_2_p8qgju.jpg",
  ];

  const storyImages = [
    "https://res.cloudinary.com/dxnjxjtwh/image/upload/v1772794813/image-post-1d4fd5a1-8947-11f0-af12-a989c10daa3f-1756959897594_2_fvbph6.png",
    "https://res.cloudinary.com/dxnjxjtwh/image/upload/v1772794813/image-post-1d4fd5a1-8947-11f0-af12-a989c10daa3f-1756959897594_2_fvbph6.png",
    "https://res.cloudinary.com/dxnjxjtwh/image/upload/v1772794813/image-post-1d4fd5a1-8947-11f0-af12-a989c10daa3f-1756959897594_2_fvbph6.png",
  ];

  useEffect(() => {
    if (!storyImages.length) return;

    const timer = setTimeout(() => {
      setPostStoryPreviewIndex((prev) =>
        prev === storyImages.length - 1 ? 0 : prev + 1,
      );
    }, 7000);

    return () => clearTimeout(timer);
  }, [postStoryPreviewIndex]);

  useEffect(() => {
    if (!scheduleDate && !scheduleTime) {
      const now = dayjs();
      setScheduleDate(now);
      setScheduleTime(now);
    }
  }, []);

  const nextSlide = () => {
    setPostPreviewIndex((prev) =>
      prev === previewImages.length - 1 ? 0 : prev + 1,
    );
  };

  const prevSlide = () => {
    setPostPreviewIndex((prev) =>
      prev === 0 ? previewImages.length - 1 : prev - 1,
    );
  };

  const storyNextSlide = () => {
    setPostStoryPreviewIndex((prev) =>
      prev === storyImages.length - 1 ? 0 : prev + 1,
    );
  };

  const storyPrevSlide = () => {
    setPostStoryPreviewIndex((prev) =>
      prev === 0 ? storyImages.length - 1 : prev - 1,
    );
  };

  const isPublished = (t: any) => t?.status === "completed";
  const isPending = (t: any) => t?.status === "pending";

  const orderedTimelineDocs = useMemo(() => {
    const items = (timelineDocs || []).filter((t) => t?.status !== "cancelled");

    const scheduledPending = items
      .filter(
        (t) =>
          t?.schedule_type === "schedule_datetime" && t?.status === "pending",
      )
      .sort(
        (a, b) =>
          dayjs(a?.schedule_datetime).valueOf() -
          dayjs(b?.schedule_datetime).valueOf(),
      );

    const postNow = items
      .filter((t) => t?.schedule_type === "post_now")
      .sort(
        (a, b) =>
          dayjs(b?.schedule_datetime).valueOf() -
          dayjs(a?.schedule_datetime).valueOf(),
      );

    const others = items.filter(
      (t) =>
        !(
          (t?.schedule_type === "schedule_datetime" &&
            t?.status === "pending") ||
          t?.schedule_type === "post_now"
        ),
    );

    return [...scheduledPending, ...postNow, ...others];
  }, [timelineDocs]);

  const CustomCalendarIcon = () => {
    return (
      <img
        src="/images/Calender.svg"
        alt="calendar"
        style={{
          width: "18px",
          height: "20px",
          opacity: 1,
        }}
      />
    );
  };

  const CustomClockIcon = () => {
    return (
      <img
        src="/images/clockicon.svg"
        alt="clock"
        style={{ width: "18px", height: "18px", opacity: 1 }}
      />
    );
  };

  const formatTimelineDateTime = (dt: string) =>
    dayjs(dt).format("MMM D, YYYY hh:mm A");

  const platformData = activePlatformKey
    ? propertyPost?.[activePlatformKey]
    : null;

  const scheduledOrPublishedDt =
    platformData?.schedule_datetime || platformData?.uploaded_at || null;

  const showScheduledFor = !!scheduledOrPublishedDt;
  const showPostLink = !!platformData?.permalink_url;

  const platformStatus =
    platformData?.status || CommonEnums.socialUploadStatus.not_started;
  const platformPermalink = platformData?.permalink_url || "-";

  const platformScheduledFor = platformData?.schedule_datetime
    ? dayjs(platformData.schedule_datetime).format("MMM D, YYYY • hh:mm A")
    : "-";

  const captionBlocks = [
    {
      key: "positioning",
      className: "block-positioning",
    },
    {
      key: "specs",
      className: "block-specs",
    },
    {
      key: "price_block",
      className: "block-price",
    },
    {
      key: "feature_summary",
      className: "block-features",
    },
    {
      key: "location_lifestyle",
      className: "block-location",
    },
    {
      key: "inspection_info",
      className: "block-inspection",
    },
    {
      key: "cta",
      className: "block-cta",
    },
    {
      key: "compliance",
      className: "block-compliance",
    },
  ];

  const applyPreferencesToUi = (prefs: any) => {
    setSelectedPlatforms((prev) => ({
      ...prev,
      Facebook: !!prefs?.facebook?.enabled,
      Instagram: !!prefs?.instagram?.enabled,
      google_business: !!prefs?.google_business?.enabled,
      LinkedIn: !!prefs?.linkedin?.enabled,
    }));

    if (prefs?.publishing_schedule === "different_for_each_platform") {
      setSameScheduleAll(false);
    } else {
      setSameScheduleAll(true);
    }
  };

  const fetchPostPreferences = useCallback(async () => {
    const postType = "property_posts";

    const res = await PostPreferencesApi.getPostPreferences(postType);

    if (res?.data?.success) {
      applyPreferencesToUi(res.data.data);
    }
  }, []);

  useEffect(() => {
    fetchPostPreferences();
  }, [fetchPostPreferences]);

  const handleSaveChanges = async () => {
    if (updating) return;

    if (!savePostPreferences) {
      toast.success("Saved");
      return;
    }

    const postType = "property_posts";

    setUpdating(true);
    try {
      const payload = {
        post_type: postType,

        facebook: { enabled: !!selectedPlatforms.Facebook },
        instagram: { enabled: !!selectedPlatforms.Instagram },
        google_business: { enabled: !!selectedPlatforms.google_business },
        linkedin: { enabled: !!selectedPlatforms.LinkedIn },

        publishing_schedule: sameScheduleAll
          ? "same_for_all_platforms"
          : "different_for_each_platform",
      };

      const res = await PostPreferencesApi.savePostPreferences(payload);

      if (res?.data?.success) {
        toast.success("Post preferences saved");
      } else {
        toast.error(res?.data?.message || "Failed to save preferences");
      }
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong");
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="setup-create-property-post">
      <div className="post-preview-wrapper-container">
        <div className="post-config-wrapper">
          <div className="post-config-top">
            <div className="post-config-heading">
              <div className="post-config-title">Post system</div>
              <div className="post-config-subtitle">
                A controlled system that generates, structures, and distributes
                every property post across platforms.
              </div>
            </div>

            <PropertyPostSystemMenuIcon
              postId={propertyPostId || ""}
              currentStatus={propertyPost?.post_status}
              disabled={updating}
              onPostNow={() => setPostNowModalOpen(true)}
              onSchedulePost={() => setScheduleModalOpen(true)}
              onUpdated={async () => {
                await fetchPost(true);
                await fetchTimeline();
              }}
            />
          </div>

          <div className="post-info-header">
            {/* <div className="info-item">
              <span className="label">Post Type</span>
              <span className="value">
                {formatPostType(propertyPost?.post_type) || "-"}
              </span>
            </div> */}

            <div className="info-item">
              <span className="label">Property Stage</span>
              <span className="value">
                {/* {propertyPost?.template_label || "-"} */}
                {propertyPost?.template_label || stageLabelFromUrl || "-"}
              </span>
            </div>

            <div className="info-item">
              <span className="label">Property</span>
              <span className="value property-link">
                <a href={`/properties/view/${propertyPost?.property_id?._id}`}>
                  {CommonHelpers.getPropertyAddress({
                    no: propertyPost?.property_id?.property_no,
                    streetName:
                      propertyPost?.property_id?.property_no_and_street_name,
                    city: propertyPost?.property_id?.city,
                    state: propertyPost?.property_id?.state,
                    postCode: propertyPost?.property_id?.post_code,
                    country: propertyPost?.property_id?.country,
                  })}
                </a>
                {/* <LinkIcon className="external-icon" /> */}
              </span>
            </div>
          </div>

          {issues.length > 0 && (
            <div className="platform-issues-stack">
              {issues.map((it) => (
                <PlatformIssueCard
                  key={it.key}
                  variant={it.variant}
                  heading={it.heading}
                  title={it.title}
                  message={it.message}
                  onRetry={
                    it.variant === "error"
                      ? () => {
                          console.log(
                            `Retry ${it.key} for property post ${propertyPostId}`,
                          );
                        }
                      : undefined
                  }
                />
              ))}
            </div>
          )}

          <div className="platform-scroll">
            <div className="platform-list">
              <button
                className={clsx("platform", {
                  active: activeTab === "Facebook",
                })}
                onClick={() => setActiveTab("Facebook")}
              >
                {activeTab === "Facebook" ? (
                  <FacebookWhiteIcon />
                ) : (
                  <FacebookIcon />
                )}
                <span className="platform-text">Facebook</span>

                <span
                  className={clsx("platform-check", {
                    checked: !!selectedPlatforms["Facebook"],
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePlatformSelected("Facebook");
                  }}
                >
                  <TrueIcon />
                </span>
              </button>

              <button
                className={clsx("platform", {
                  active: activeTab === "Instagram",
                })}
                onClick={() => setActiveTab("Instagram")}
              >
                {activeTab === "Instagram" ? (
                  <InstagramWhiteIcon />
                ) : (
                  <InstagramIcon />
                )}
                <span className="platform-text">Instagram</span>

                <span
                  className={clsx("platform-check", {
                    checked: !!selectedPlatforms["Instagram"],
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePlatformSelected("Instagram");
                  }}
                >
                  <TrueIcon />
                </span>
              </button>

              <button
                className={clsx("platform", {
                  active: activeTab === "google_business",
                })}
                onClick={() => setActiveTab("google_business")}
              >
                {activeTab === "google_business" ? (
                  <GoogleBusinessWhiteIcon />
                ) : (
                  <GoogleBusinessIcon />
                )}
                <span className="platform-text">Google Business</span>

                <span
                  className={clsx("platform-check", {
                    checked: !!selectedPlatforms["google_business"],
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePlatformSelected("google_business");
                  }}
                >
                  <TrueIcon />
                </span>
              </button>

              <button
                className={clsx("platform", {
                  active: activeTab === "LinkedIn",
                })}
                onClick={() => setActiveTab("LinkedIn")}
              >
                {activeTab === "LinkedIn" ? (
                  <LinkedInWhiteIcon />
                ) : (
                  <LinkedInIcon />
                )}
                <span className="platform-text">LinkedIn</span>

                <span
                  className={clsx("platform-check", {
                    checked: !!selectedPlatforms["LinkedIn"],
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePlatformSelected("LinkedIn");
                  }}
                >
                  <TrueIcon />
                </span>
              </button>

              {/* <button
                className={clsx("platform", { active: activeTab === "X.com" })}
                onClick={() => setActiveTab("X.com")}
              >
                {activeTab === "X.com" ? <XWhiteIcon /> : <XIcon />}
                <span className="platform-text">X.com</span>

                <span
                  className={clsx("platform-check", {
                    checked: !!selectedPlatforms["X.com"],
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePlatformSelected("X.com");
                  }}
                >
                  <TrueIcon />
                </span>
              </button> */}

              <button
                type="button"
                className={clsx("platform", {
                  active: activeTab === "TikTok",
                  locked: isLocked("TikTok"),
                })}
                onClick={() => {
                  if (isLocked("TikTok")) return;
                  setActiveTab("TikTok");
                }}
                disabled={isLocked("TikTok")}
              >
                {activeTab === "TikTok" ? <TikTokWhiteIcon /> : <TikTokIcon />}
                <span className="platform-text">TikTok</span>
                <span className="platform-lock">
                  <LockIcon2 />
                </span>
              </button>

              <button
                type="button"
                className={clsx("platform", {
                  active: activeTab === "YouTube",
                  locked: isLocked("YouTube"),
                })}
                onClick={() => {
                  if (isLocked("YouTube")) return;
                  setActiveTab("YouTube");
                }}
                disabled={isLocked("YouTube")}
              >
                {activeTab === "YouTube" ? (
                  <YouTubeWhiteIcon />
                ) : (
                  <YouTubeIcon />
                )}
                <span className="platform-text">YouTube</span>
                <span className="platform-lock">
                  <LockIcon2 />
                </span>
              </button>
            </div>
          </div>

          <div className="platform-post-config">
            <div className="platform-post-config-top">
              <div>
                <div className="platform-post-title">{activeTab} post</div>
                <div className="platform-post-subtitle">
                  Manage social media post for {activeTab}
                </div>
              </div>

              <PropertyPlatformPostMenuIcon
                disabled={
                  updating ||
                  !activePlatformKey ||
                  !selectedPlatforms[activeTab]
                }
                onPublishNow={openPlatformPostNow}
                onSchedulePost={openPlatformSchedule}
                onCancelSchedule={handlePlatformCancelSchedule}
                onRetryPost={() => toast("Retry post - TODO")}
                onViewErrors={() => toast("View errors - TODO")}
              />
            </div>

            <div className="platform-post-meta">
              <div className="meta-item">
                <div className="meta-label">Status</div>
                <div className="status-pill">
                  {platformStatus ===
                  CommonEnums.socialUploadStatus.pending_for_social_media_upload
                    ? "Pending"
                    : platformStatus}
                </div>
              </div>

              <div className="meta-item">
                <div className="meta-label">Post link</div>

                {platformData?.permalink_url ? (
                  <button
                    type="button"
                    className="show-post-link"
                    onClick={() =>
                      window.open(
                        platformData.permalink_url,
                        "_blank",
                        "noopener,noreferrer",
                      )
                    }
                  >
                    Show post
                  </button>
                ) : (
                  <div className="meta-value">-</div>
                )}
              </div>

              {showScheduledFor && (
                <div className="meta-item">
                  <div className="meta-label">Scheduled for</div>
                  <div className="meta-value">{platformScheduledFor}</div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <div className="configure-post">
          <h3 className="section-title">Configure Post</h3>
          <div className="right-actions">
            <div className="right-actions">
              <button
                className="preview"
                disabled={!hasPendingForUpload}
                onClick={() => setIsPreviewOpen(true)}
              >
                Preview
              </button>
              <button
                className="change-template"
                disabled={!hasPendingForUpload}
                onClick={() => setIsUpdateTemplateOpen(true)}
              >
                Change Template
              </button>
            </div>
          </div>
        </div> */}

        <div className="post-preview-wrapper">
          {/* {hasPendingForUpload ? (
            <div className="post-preview-card">
              <div className="post-header">
                <img
                  src={
                    getImageUrl(
                      propertyPost?.agent_ref?.profile_image_ref
                        ?.compressed_file_path || "",
                    ) || "/images/profile-placeholder-image.png"
                  }
                  alt="Agent"
                  className="avatar"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src =
                      "/images/profile-placeholder-image.png";
                  }}
                />
                <div className="user-info">
                  <strong className="name">
                    {propertyPost.agent_ref?.principal_agent_first_name}{" "}
                    {propertyPost.agent_ref?.principal_agent_last_name}
                  </strong>
                  <span className="date">{formattedSchedule}</span>
                </div>
              </div>

              <div className="post-text">
                <span className="post-content">
                  {isExpanded ? fullText : shortText}
                </span>
                <span className="see-more" onClick={toggleExpand}>
                  {isExpanded ? " See less" : " See more"}
                </span>
              </div>

              <div className="carousel-container">
                {renderDesignImage(
                  [
                    propertyPost?.image_post_design_activity_ref,
                    propertyPost?.story_post_design_activity_ref,
                    propertyPost?.video_post_design_activity_ref,
                    propertyPost?.reel_post_design_activity_ref,
                  ].filter(Boolean)[postPreviewIndex],
                )}

                {[
                  propertyPost?.image_post_design_activity_ref,
                  propertyPost?.story_post_design_activity_ref,
                  propertyPost?.video_post_design_activity_ref,
                  propertyPost?.reel_post_design_activity_ref,
                ].filter(Boolean).length > 1 && (
                  <>
                    <button
                      className="carousel-button left"
                      onClick={() =>
                        setPostPreviewIndex((prev) =>
                          prev === 0
                            ? [
                                propertyPost?.image_post_design_activity_ref,
                                propertyPost?.story_post_design_activity_ref,
                                propertyPost?.video_post_design_activity_ref,
                                propertyPost?.reel_post_design_activity_ref,
                              ].filter(Boolean).length - 1
                            : prev - 1,
                        )
                      }
                    >
                      <LeftArrowIcon />
                    </button>

                    <button
                      className="carousel-button right"
                      onClick={() =>
                        setPostPreviewIndex((prev) =>
                          prev ===
                          [
                            propertyPost?.image_post_design_activity_ref,
                            propertyPost?.story_post_design_activity_ref,
                            propertyPost?.video_post_design_activity_ref,
                            propertyPost?.reel_post_design_activity_ref,
                          ].filter(Boolean).length -
                            1
                            ? 0
                            : prev + 1,
                        )
                      }
                    >
                      <RightArrowIcon />
                    </button>
                  </>
                )}
              </div>

              {[
                propertyPost?.image_post_design_activity_ref,
                propertyPost?.story_post_design_activity_ref,
                propertyPost?.video_post_design_activity_ref,
                propertyPost?.reel_post_design_activity_ref,
              ].filter(Boolean).length > 1 && (
                <div className="dots-pagination">
                  {[
                    propertyPost?.image_post_design_activity_ref,
                    propertyPost?.story_post_design_activity_ref,
                    propertyPost?.video_post_design_activity_ref,
                    propertyPost?.reel_post_design_activity_ref,
                  ]
                    .filter(Boolean)
                    .map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${
                          i === postPreviewIndex ? "active" : ""
                        }`}
                        onClick={() => setPostPreviewIndex(i)}
                      />
                    ))}
                </div>
              )}
            </div>
          ) : (
            <div className="post-preview-loading">
              <div className="spinner" />
              <h4>Your request is being processed.</h4>
              <p>
                We’re working on your request! Creating a high-quality output
                can take a little while. We appreciate your patience.
              </p>
              <p className="message">
                Feel free to wait here, or browse other pages. We’ll send you a
                notification when your request is completed.
              </p>
            </div>
          )} */}
          <div className="previews-container">
            <div className="preview-column">
              <h3>Image post preview</h3>
              <div className="post-preview-card">
                <div className="post-header">
                  <img
                    // src={
                    //   getImageUrl(
                    //     propertyPost?.agent_ref?.profile_image_ref
                    //       ?.compressed_file_path || "",
                    //   ) || "/images/profile-placeholder-image.png"
                    // }
                    src={
                      getAgentProfileImageUrl(
                        propertyPost?.agent_ref?.profile_image_ref,
                      ) ||
                      getImageUrl(
                        propertyPost?.agent_ref?.profile_image_ref
                          ?.compressed_file_path || "",
                      ) ||
                      "/images/profile-placeholder-image.png"
                    }
                    alt="Agent"
                    className="avatar"
                  />
                  <div className="user-info">
                    <span className="name">
                      {propertyPost?.agent_ref?.principal_agent_first_name}{" "}
                      {propertyPost?.agent_ref?.principal_agent_last_name}
                    </span>
                    <span className="date">{formattedSchedule}</span>
                  </div>
                </div>

                <div className="post-text">
                  {isEditingCaption ? (
                    <div className="edit-caption-wrapper">
                      <label className="caption-label">Post caption</label>

                      <textarea
                        className="caption-textarea"
                        value={postCaption}
                        onChange={(e) => setPostCaption(e.target.value)}
                        rows={12}
                      />

                      <div className="edit-actions-row">
                        <button
                          className="save-btn"
                          onClick={handleSaveCaption}
                        >
                          Save
                        </button>

                        <button
                          className="cancel-btn"
                          onClick={handleCancelCaption}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="post-caption-blocks">
                      {captionBlocks.map((block) => {
                        const value =
                          propertyPost?.post_text?.generated_blocks?.[
                            block.key as keyof typeof propertyPost.post_text.generated_blocks
                          ];

                        if (!value) return null;

                        return (
                          <div
                            key={block.key}
                            className={`caption-block ${block.className}`}
                          >
                            {value}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                <div className="carousel-container">
                  <img
                    src={previewImages[postPreviewIndex]}
                    className="carousel-image"
                    alt="Post Preview"
                  />

                  <button className="carousel-button left" onClick={prevSlide}>
                    <LeftArrowIcon />
                  </button>

                  <button className="carousel-button right" onClick={nextSlide}>
                    <RightArrowIcon />
                  </button>

                  <div className="dots-pagination">
                    {previewImages.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === postPreviewIndex ? "active" : ""}`}
                        onClick={() => setPostPreviewIndex(i)}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <div className="preview-actions-footer">
                <div className="toggle-row">
                  <span>Same caption for all the platforms</span>
                  <label className="switch">
                    <input type="checkbox" />
                    <span className="slider"></span>
                  </label>
                </div>
                <div className="button-group">
                  <button className="action-btn">
                    <CustomizeImageIcon /> Customize image
                  </button>
                  <button
                    className={`action-btn ${isEditingCaption ? "active" : ""}`}
                    onClick={() => setIsEditingCaption(true)}
                  >
                    <EditCaptionIcon /> Edit caption
                  </button>
                  <button className="action-btn">
                    <PreviewCircleIcon /> Preview
                  </button>
                  <button className="action-btn">
                    <DownloadIcon /> Download
                  </button>
                </div>
              </div>
            </div>

            <div className="preview-column">
              <h3>Story post preview</h3>
              <div className="story-preview-card">
                <div className="story-carousel-wrapper">
                  <button
                    className="carousel-button left"
                    onClick={storyPrevSlide}
                  >
                    <LeftArrowIcon />
                  </button>

                  <div className="story-inner-frame">
                    <div className="story-progress-bars">
                      {storyImages.map((_, i) => {
                        let progressClass = "";

                        if (i < postStoryPreviewIndex) {
                          progressClass = "completed";
                        } else if (i === postStoryPreviewIndex) {
                          progressClass = "active";
                        }

                        return (
                          <div key={i} className="bar">
                            <div
                              key={`${i}-${postStoryPreviewIndex}`}
                              className={`progress ${progressClass}`}
                            />
                          </div>
                        );
                      })}
                    </div>

                    <div className="story-header">
                      <img
                        // src={getImageUrl(
                        //   propertyPost?.agent_ref?.profile_image_ref
                        //     ?.compressed_file_path || "",
                        // )}
                        src={
                          getAgentProfileImageUrl(
                            propertyPost?.agent_ref?.profile_image_ref,
                          ) ||
                          getImageUrl(
                            propertyPost?.agent_ref?.profile_image_ref
                              ?.compressed_file_path || "",
                          ) ||
                          "/images/profile-placeholder-image.png"
                        }
                        className="story-avatar"
                      />
                      <span className="story-user-name">
                        {propertyPost?.agent_ref?.principal_agent_first_name}{" "}
                        {propertyPost?.agent_ref?.principal_agent_last_name}
                      </span>
                      <p className="story-uploaded-time">3h</p>
                    </div>

                    <img
                      src={storyImages[postStoryPreviewIndex]}
                      className="story-main-img"
                    />

                    <div className="story-footer">
                      <div className="reply-bar">Reply to username...</div>
                    </div>
                  </div>

                  <button
                    className="carousel-button right"
                    onClick={storyNextSlide}
                  >
                    <RightArrowIcon />
                  </button>
                </div>
              </div>

              <div className="preview-actions-footer">
                <div className="toggle-row">
                  <span>
                    Always share story (Only for Facebook and Instagram)
                  </span>
                  <label className="switch">
                    <input type="checkbox" defaultChecked />
                    <span className="slider"></span>
                  </label>
                </div>
                <div className="button-group">
                  <button className="action-btn">
                    <PreviewCircleIcon /> Preview
                  </button>
                  <button className="action-btn">
                    <DownloadIcon /> Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="text-config">
        <div className="post-text-header">
          <h4>Post Text</h4>
          <div className="toggle-same-text">
            <label className="switch-label">
              Same text for all the platforms
              <input
                type="checkbox"
                checked={sameTextToggle}
                onChange={() => setSameTextToggle(!sameTextToggle)}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
        <div className="platform-header">
          <div className="platform-tabs">
            {tabs.map((tab) => (
              <div
                key={tab}
                className={`platform-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
        </div>

        <textarea
          className="post-textarea"
          placeholder="Write your post content here..."
          defaultValue={propertyPost?.post_text || ""}
          onInput={(e: React.FormEvent<HTMLTextAreaElement>) => {
            const target = e.currentTarget;
            target.style.height = "auto";
            target.style.height = `${target.scrollHeight}px`;
          }}
        />
      </div> */}

      <div className="property-post-form">
        <div className="publish-schedule-block">
          <h3 className="section-title">Publishing schedule</h3>
          <p className="section-sub-title">
            Choose whether to publish your post immediately or schedule it for a
            future date and time
          </p>

          <div className="publish-actions">
            <button
              type="button"
              className="schedule-action-btn"
              onClick={() => setPostNowModalOpen(true)}
              disabled={updating}
            >
              Post now
            </button>

            <button
              type="button"
              className="schedule-action-btn"
              onClick={() => setScheduleModalOpen(true)}
              disabled={updating}
            >
              Schedule post
            </button>
          </div>
        </div>

        <div className="save-post-preferences-row">
          <label className="save-post-preferences-left">
            <input
              type="checkbox"
              checked={savePostPreferences}
              onChange={(e) => setSavePostPreferences(e.target.checked)}
            />

            <span
              className={clsx("custom-checkbox", {
                checked: savePostPreferences,
              })}
              aria-hidden="true"
            >
              <TrueIcon />
            </span>

            <span className="save-post-preferences-text">
              Save post preferences
            </span>
          </label>

          <button
            type="button"
            className="preferences-info-btn"
            onClick={() => setPostPreferencesModalOpen(true)}
            aria-label="Post preferences info"
            title="Post preferences info"
          >
            <img src="/images/Information.svg" alt="info" />
          </button>
        </div>

        <div className="timeline-block">
          <h3 className="section-title">Post timeline</h3>
          <p className="section-sub-title">
            Published history and manage upcoming schedules
          </p>

          {timelineLoading ? (
            <div className="timeline-empty-box">
              <div className="empty-title">Loading timeline...</div>
            </div>
          ) : orderedTimelineDocs.length === 0 ? (
            <div className="timeline-empty-box">
              <div className="empty-title">Timeline is empty</div>
              <div className="empty-subtitle">
                Once you schedule or publish a post, the timeline will update
              </div>
            </div>
          ) : (
            <div className="timeline-list">
              {orderedTimelineDocs.map((t, idx) => {
                const isLast = idx === orderedTimelineDocs.length - 1;
                const published = isPublished(t);

                return (
                  <div
                    key={t?._id || idx}
                    className={clsx(
                      "timeline-item",
                      published ? "published" : "scheduled",
                    )}
                  >
                    <div
                      className={clsx("timeline-left", { "has-line": !isLast })}
                    >
                      {published ? (
                        <div className="timeline-icon timeline-icon--success">
                          <TrueIcon />
                        </div>
                      ) : (
                        <div className="timeline-icon timeline-icon--pending">
                          <img src="/images/pending-icon-2.png" alt="pending" />
                        </div>
                      )}
                    </div>

                    <div className="timeline-content">
                      <div className="timeline-pill">
                        {published
                          ? t?.schedule_type === "schedule_datetime"
                            ? "Published via Scheduled Post"
                            : "Published via Post Now"
                          : "Scheduled post"}
                      </div>

                      <div className="timeline-label">
                        {published ? "Published on" : "To be published on"}
                      </div>

                      <div className="timeline-datetime">
                        {t?.schedule_datetime
                          ? formatTimelineDateTime(t.schedule_datetime)
                          : "-"}
                      </div>

                      {!published &&
                        t?.schedule_type === "schedule_datetime" &&
                        isPending(t) &&
                        propertyPost?.schedule_type === "schedule_datetime" &&
                        propertyPost?.schedule_datetime &&
                        dayjs(propertyPost.schedule_datetime).isSame(
                          dayjs(t.schedule_datetime),
                        ) && (
                          <div className="timeline-actions">
                            <button
                              type="button"
                              className="timeline-link cancel"
                              onClick={() => setCancelScheduleModalOpen(true)}
                              disabled={updating}
                            >
                              Cancel
                            </button>

                            <button
                              type="button"
                              className="timeline-link edit"
                              onClick={handleOpenEditSchedule}
                              disabled={updating}
                            >
                              Edit schedule
                            </button>
                          </div>
                        )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="schedule-footer-actions">
          <button
            type="button"
            className="back-btn"
            onClick={() => {
              const next = new URLSearchParams(searchParams);
              next.set("step", CommonEnums.propertyPost.property_info.key);
              setSearchParams(next);
            }}
          >
            Back
          </button>

          <button
            type="button"
            className="save-btn"
            onClick={handleSaveChanges}
            disabled={updating}
          >
            Save changes
          </button>
        </div>
      </div>

      <Modal
        open={platformPostNowOpen}
        onClose={() => setPlatformPostNowOpen(false)}
        className="property-post-now-modal"
      >
        <div className="post-now-modal-card">
          <h3 className="modal-title">Post to {activePlatformLabel} now?</h3>

          <p className="modal-desc">
            Are you sure you want to go live?
            <br />
            Your post will be published to your {activePlatformLabel} page
            instantly.
          </p>

          <div className="modal-actions">
            <button
              type="button"
              className="modal-btn outline"
              onClick={() => setPlatformPostNowOpen(false)}
              disabled={updating}
            >
              Cancel
            </button>

            <button
              type="button"
              className="modal-btn primary"
              disabled={updating}
              onClick={async () => {
                await handlePlatformPostNow();
                setPlatformPostNowOpen(false);
              }}
            >
              Post now
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        open={platformScheduleOpen}
        onClose={() => setPlatformScheduleOpen(false)}
        className="property-post-schedule-modal"
      >
        <div className="schedule-post-modal-card">
          <h3 className="modal-title modal-title--left">
            Schedule {activePlatformLabel} Post
          </h3>

          <p className="modal-desc modal-desc--left">
            Select your preferred date and time
            <br />
            Your content will be published to your {activePlatformLabel} Page
            automatically at the scheduled time
          </p>

          <div className="datetime-row plateform-datetime-row">
            <div className="datetime-field">
              <label>Date*</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  desktopModeMediaQuery="@media (min-width: 0px)"
                  value={platformScheduleDate}
                  onChange={(v) => setPlatformScheduleDate(v)}
                  format="DD/MM/YYYY"
                  slots={{
                    textField: TextField,
                    openPickerIcon: CustomCalendarIcon,
                  }}
                  disablePast
                  slotProps={{
                    openPickerButton: {
                      sx: { display: "inline-flex", opacity: 1 },
                    },
                    textField: {
                      placeholder: "DD/MM/YYYY",
                      sx: {
                        width: 200,
                        "& .MuiOutlinedInput-root": {
                          height: 40,
                          borderRadius: "8px",
                          background: "#F5F5F5",
                          "& fieldset": { border: "0px" },
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            <div className="datetime-field">
              <label>Time*</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  desktopModeMediaQuery="@media (min-width: 0px)"
                  value={platformScheduleTime}
                  onChange={(v) => setPlatformScheduleTime(v)}
                  ampm
                  format="hh:mm A"
                  slots={{
                    textField: TextField,
                    openPickerIcon: CustomClockIcon,
                  }}
                  slotProps={{
                    openPickerButton: {
                      sx: { display: "inline-flex", opacity: 1 },
                    },
                    textField: {
                      placeholder: "00:00 AM",
                      sx: {
                        width: 200,
                        "& .MuiOutlinedInput-root": {
                          height: 40,
                          borderRadius: "8px",
                          background: "#F5F5F5",
                          "& fieldset": { border: "0px" },
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>
          </div>

          <p className="schedule-note">
            *Automatically scheduled time for peak engagement
          </p>

          <div className="modal-actions modal-actions--left">
            <button
              type="button"
              className="modal-btn outline"
              onClick={() => setPlatformScheduleOpen(false)}
              disabled={updating}
            >
              Cancel
            </button>

            <button
              type="button"
              className="modal-btn primary"
              onClick={handlePlatformSchedule}
              disabled={updating}
            >
              Schedule
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        open={postNowModalOpen}
        onClose={() => setPostNowModalOpen(false)}
        className="property-post-now-modal"
      >
        <div className="post-now-modal-card">
          <h3 className="modal-title">Publish property post now?</h3>

          <p className="modal-desc">
            This will publish the property post to social media immediately.
            <br />
            Are you sure you want to proceed?
          </p>

          <div className="modal-actions">
            <button
              type="button"
              className="modal-btn outline"
              onClick={() => setPostNowModalOpen(false)}
              disabled={updating}
            >
              Cancel
            </button>

            <button
              type="button"
              className="modal-btn primary"
              disabled={updating}
              onClick={async () => {
                await handlePostNow();
                setPostNowModalOpen(false);
              }}
            >
              Post now
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        open={cancelScheduleModalOpen}
        onClose={() => setCancelScheduleModalOpen(false)}
        className="property-post-cancel-schedule-modal"
      >
        <div className="cancel-schedule-modal-card">
          <h3 className="modal-title">Cancel post schedule?</h3>

          <p className="modal-desc">
            This post will no longer be published at the scheduled date and time
          </p>

          <div className="modal-actions">
            <button
              type="button"
              className="modal-btn outline"
              onClick={() => setCancelScheduleModalOpen(false)}
              disabled={updating}
            >
              Cancel
            </button>

            <button
              type="button"
              className="modal-btn primary"
              onClick={handleConfirmCancelSchedule}
              disabled={updating}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        open={editScheduleModalOpen}
        onClose={() => setEditScheduleModalOpen(false)}
        className="property-post-edit-schedule-modal"
      >
        <div className="schedule-post-modal-card">
          <h3 className="modal-title modal-title--left">Edit schedule</h3>

          <p className="modal-desc modal-desc--left">
            Set the date and time for your post
            <br />
            It will be published to social media automatically at your chosen
            time
          </p>

          <div className="datetime-row">
            <div className="datetime-field">
              <label>Date*</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  desktopModeMediaQuery="@media (min-width: 0px)"
                  value={scheduleDate}
                  onChange={(newValue) => setScheduleDate(newValue)}
                  format="DD/MM/YYYY"
                  slots={{
                    textField: TextField,
                    openPickerIcon: CustomCalendarIcon,
                  }}
                  disablePast
                  slotProps={{
                    openPickerButton: {
                      sx: {
                        display: "inline-flex",
                        visibility: "visible",
                        opacity: 1,
                        flexShrink: 0,
                      },
                    },
                    textField: {
                      placeholder: "DD/MM/YYYY",
                      sx: {
                        width: 200,
                        "& .MuiOutlinedInput-root": {
                          height: 40,
                          borderRadius: "8px",
                          background: "#F5F5F5",
                          "& fieldset": { border: "0px" },
                        },

                        "& input": {
                          padding: "10px 14px",
                          fontFamily: "var(--inter)",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "100%",
                          letterSpacing: "0.01em",
                          color: "#111111",
                        },

                        "& .MuiInputAdornment-root": {
                          order: -1,
                          marginRight: "8px",
                          marginLeft: "0px",
                          display: "flex",
                        },
                        "& .MuiIconButton-root": {
                          display: "inline-flex",
                          visibility: "visible",
                          opacity: 1,
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            <div className="datetime-field">
              <label>Time*</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  desktopModeMediaQuery="@media (min-width: 0px)"
                  value={scheduleTime}
                  onChange={(newValue) => setScheduleTime(newValue)}
                  ampm
                  format="hh:mm A"
                  slots={{
                    textField: TextField,
                    openPickerIcon: CustomClockIcon,
                  }}
                  slotProps={{
                    openPickerButton: {
                      sx: {
                        display: "inline-flex",
                        visibility: "visible",
                        opacity: 1,
                        flexShrink: 0,
                      },
                    },
                    textField: {
                      placeholder: "00:00 AM",
                      sx: {
                        width: 200,
                        "& .MuiOutlinedInput-root": {
                          height: 40,
                          borderRadius: "8px",
                          background: "#F5F5F5",
                          "& fieldset": { border: "0px" },
                        },
                        "& input": {
                          padding: "10px 14px",
                          fontFamily: "var(--inter)",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "100%",
                          letterSpacing: "0.01em",
                          color: "#111111",
                        },
                        "& .MuiInputAdornment-root": {
                          order: -1,
                          marginRight: "8px",
                          marginLeft: "0px",
                          display: "flex",
                        },
                        "& .MuiIconButton-root": {
                          display: "inline-flex",
                          visibility: "visible",
                          opacity: 1,
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>
          </div>

          <div className="modal-actions modal-actions--left">
            <button
              type="button"
              className="modal-btn outline"
              onClick={() => setEditScheduleModalOpen(false)}
              disabled={updating}
            >
              Cancel
            </button>

            <button
              type="button"
              className="modal-btn primary"
              onClick={handleConfirmSchedule}
              disabled={updating}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        open={scheduleModalOpen}
        onClose={() => setScheduleModalOpen(false)}
        className="property-post-schedule-modal"
      >
        <div className="schedule-post-modal-card">
          <h3 className="modal-title modal-title--left">Schedule post</h3>

          <p className="modal-desc modal-desc--left">
            Set the date and time for your post
            <br />
            It will be published to social media automatically at your chosen
            time
          </p>

          <div className="same-schedule-row">
            <span>Same schedule for all social media accounts</span>

            <label className="same-schedule-switch">
              <input
                type="checkbox"
                checked={sameScheduleAll}
                onChange={(e) => setSameScheduleAll(e.target.checked)}
              />
              <span className="slider" />
            </label>
          </div>

          {sameScheduleAll ? (
            <>
              <div className="datetime-row">
                <div className="datetime-field">
                  <label>Date*</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      desktopModeMediaQuery="@media (min-width: 0px)"
                      value={scheduleDate}
                      onChange={(newValue) => setScheduleDate(newValue)}
                      format="DD/MM/YYYY"
                      slots={{
                        textField: TextField,
                        openPickerIcon: CustomCalendarIcon,
                      }}
                      disablePast
                      slotProps={{
                        openPickerButton: {
                          sx: {
                            display: "inline-flex",
                            visibility: "visible",
                            opacity: 1,
                            flexShrink: 0,
                          },
                        },
                        textField: {
                          placeholder: "DD/MM/YYYY",
                          sx: {
                            width: 200,
                            "& .MuiOutlinedInput-root": {
                              height: 40,
                              borderRadius: "8px",
                              background: "#F5F5F5",
                              "& fieldset": { border: "0px" },
                            },
                            "& input": {
                              padding: "10px 14px",
                              fontFamily: "var(--inter)",
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "100%",
                              letterSpacing: "0.01em",
                              color: "#111111",
                            },
                            "& .MuiInputAdornment-root": {
                              order: -1,
                              marginRight: "8px",
                              marginLeft: "0px",
                              display: "flex",
                            },
                            "& .MuiIconButton-root": {
                              display: "inline-flex",
                              visibility: "visible",
                              opacity: 1,
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>

                <div className="datetime-field">
                  <label>Time*</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      desktopModeMediaQuery="@media (min-width: 0px)"
                      value={scheduleTime}
                      onChange={(newValue) => setScheduleTime(newValue)}
                      ampm
                      format="hh:mm A"
                      slots={{
                        textField: TextField,
                        openPickerIcon: CustomClockIcon,
                      }}
                      slotProps={{
                        openPickerButton: {
                          sx: {
                            display: "inline-flex",
                            visibility: "visible",
                            opacity: 1,
                            flexShrink: 0,
                          },
                        },
                        textField: {
                          placeholder: "00:00 AM",
                          sx: {
                            width: 200,
                            "& .MuiOutlinedInput-root": {
                              height: 40,
                              borderRadius: "8px",
                              background: "#F5F5F5",
                              "& fieldset": { border: "0px" },
                            },
                            "& input": {
                              padding: "10px 14px",
                              fontFamily: "var(--inter)",
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "100%",
                              letterSpacing: "0.01em",
                              color: "#111111",
                            },
                            "& .MuiInputAdornment-root": {
                              order: -1,
                              marginRight: "8px",
                              marginLeft: "0px",
                              display: "flex",
                            },
                            "& .MuiIconButton-root": {
                              display: "inline-flex",
                              visibility: "visible",
                              opacity: 1,
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>

              <p className="schedule-note">
                *Automatically scheduled time for peak engagement
              </p>
            </>
          ) : (
            <>
              <div className="platform-schedule-grid">
                {SCHEDULE_PLATFORMS.filter(
                  (p) => !!selectedPlatforms[p.selectedKey],
                ).map(({ key, label, Icon, supported }) => {
                  const v = perPlatformSchedule[key];

                  return (
                    <div
                      key={key}
                      className={clsx("platform-schedule-card", {
                        "platform-schedule-card--disabled": supported === false,
                      })}
                    >
                      <div className="platform-schedule-card-header">
                        <span className="platform-schedule-card-icon">
                          <Icon />
                        </span>
                        <span className="platform-schedule-card-title">
                          {label}
                        </span>
                      </div>

                      <div className="platform-card-datetime platform-card-datetime--joined">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            desktopModeMediaQuery="@media (min-width: 0px)"
                            value={v.date}
                            onChange={(newDate) =>
                              setPerPlatformSchedule((prev) => ({
                                ...prev,
                                [key]: { ...prev[key], date: newDate },
                              }))
                            }
                            format="DD/MM/YYYY"
                            slots={{
                              textField: TextField,
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            disablePast
                            slotProps={{
                              openPickerButton: {
                                sx: {
                                  display: "inline-flex",
                                  visibility: "visible",
                                  opacity: 1,
                                  flexShrink: 0,
                                },
                              },
                              textField: {
                                sx: {
                                  width: 150,
                                  "& .MuiOutlinedInput-root": {
                                    height: 40,
                                    borderRadius: "8px 0 0 8px",
                                    background: "#F5F5F5",
                                    paddingRight: "0px !important",
                                    "& fieldset": { border: "0px" },
                                  },
                                  "& input": {
                                    padding: "10px 14px",
                                    fontFamily: "var(--inter)",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.01em",
                                    color: "#111111",
                                  },
                                  "& .MuiInputAdornment-root": {
                                    order: -1,
                                    marginRight: "8px",
                                    marginLeft: "0px",
                                    display: "flex",
                                  },
                                  "& .MuiIconButton-root": {
                                    display: "inline-flex",
                                    visibility: "visible",
                                    opacity: 1,
                                  },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>

                        <div className="joined-divider" />

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            desktopModeMediaQuery="@media (min-width: 0px)"
                            value={v.time}
                            onChange={(newTime) =>
                              setPerPlatformSchedule((prev) => ({
                                ...prev,
                                [key]: { ...prev[key], time: newTime },
                              }))
                            }
                            ampm
                            format="hh:mm A"
                            slots={{
                              textField: TextField,
                              openPickerIcon: CustomClockIcon,
                            }}
                            slotProps={{
                              openPickerButton: {
                                sx: {
                                  display: "inline-flex",
                                  visibility: "visible",
                                  opacity: 1,
                                  flexShrink: 0,
                                },
                              },
                              textField: {
                                sx: {
                                  width: 130,
                                  "& .MuiOutlinedInput-root": {
                                    height: 40,
                                    borderRadius: "0 8px 8px 0",
                                    background: "#F5F5F5",
                                    paddingRight: "0px !important",
                                    "& fieldset": { border: "0px" },
                                  },
                                  "& input": {
                                    padding: "10px 14px",
                                    fontFamily: "var(--inter)",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.01em",
                                    color: "#111111",
                                  },
                                  "& .MuiInputAdornment-root": {
                                    order: -1,
                                    marginRight: "8px",
                                    marginLeft: "0px",
                                    display: "flex",
                                  },
                                  "& .MuiIconButton-root": {
                                    display: "inline-flex",
                                    visibility: "visible",
                                    opacity: 1,
                                  },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      <p className="schedule-note schedule-note--card">
                        *Automatically scheduled time for peak engagement
                      </p>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          <div className="modal-actions modal-actions--left">
            <button
              type="button"
              className="modal-btn outline"
              onClick={() => setScheduleModalOpen(false)}
              disabled={updating}
            >
              Cancel
            </button>

            <button
              type="button"
              className="modal-btn primary"
              onClick={handleConfirmSchedule}
              disabled={updating}
            >
              Schedule
            </button>
          </div>
        </div>
      </Modal>

      {/* {isUpdateTemplateOpen && propertyPostId && (
        <UpdateTemplateModal
          open={isUpdateTemplateOpen}
          onClose={() => setIsUpdateTemplateOpen(false)}
          selectedDesignTemplateId={getSelectedTemplateId()}
          onConfirm={async () => {
            try {
              setProcessingModalOpen(true);
              setIsProcessing(true);
              await PropertyApi.updatePropertyPost(propertyPostId, {
                finalize: true,
              });
              setIsProcessing(false);
              setProcessingModalOpen(false);
              setIsUpdateTemplateOpen(false);
              // window.location.reload();
              await fetchPost(true);
            } catch (err) {
              console.error("Finalize failed:", err);
              toast.error("Failed to finalize");
            }
          }}
        />
      )} */}

      <Modal
        open={processingModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setProcessingModalOpen(false);
          }
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            {isProcessing && (
              <div className="loading-container">
                <div className="spinner" />
                <p className="loading-text">
                  Processing your request
                  <span className="desktop-break">
                    <br />
                  </span>
                  Please wait...
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        open={postPreferencesModalOpen}
        onClose={() => setPostPreferencesModalOpen(false)}
        className="post-preferences-modal"
      >
        <div className="post-preferences-modal-card">
          <div className="ppm-content">
            <h3 className="ppm-title">Post preferences</h3>

            <div className="ppm-section">
              <div className="ppm-section-title">Social media platforms</div>

              <div className="ppm-section-desc">
                Your selected social media accounts will be saved and
                automatically applied when you create new property posts
              </div>
            </div>

            <div className="ppm-section pp-section">
              <div className="ppm-section-title">Publishing schedule</div>

              <div className="ppm-section-desc">
                Your schedule preferences—whether you use the same timing for
                all platforms or set different times for each—will be saved for
                your next session
              </div>
            </div>

            <div className="ppm-footnote">
              *You can always review and change these settings for any
              individual post
            </div>

            <div className="ppm-actions">
              <button
                type="button"
                className="ppm-done-btn"
                onClick={() => setPostPreferencesModalOpen(false)}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {isPreviewOpen && (
        <PreviewModal
          open={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
          images={
            [
              propertyPost?.image_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: propertyPost.image_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
              propertyPost?.story_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: propertyPost.story_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
              propertyPost?.video_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: propertyPost.video_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
              propertyPost?.reel_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: propertyPost.reel_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
            ].filter(Boolean) as string[]
          }
          initialIndex={postPreviewIndex}
        />
      )}

      <div
        className={clsx("publish-box", {
          closed: !isFloatingPublishOpen,
        })}
      >
        <button
          type="button"
          className="publish-handle"
          onClick={() => setIsFloatingPublishOpen(true)}
          aria-label="Open publish actions"
        >
          <LeftArrowIcon />
        </button>

        <div className="publish-panel">
          <div className="publish-actions">
            <button
              type="button"
              className="publish-btn"
              onClick={() => setPostNowModalOpen(true)}
              disabled={updating}
            >
              Post now
            </button>

            <button
              type="button"
              className="publish-btn"
              onClick={() => setScheduleModalOpen(true)}
              disabled={updating}
            >
              Schedule post
            </button>
          </div>

          <button
            type="button"
            className="publish-collapse"
            onClick={() => setIsFloatingPublishOpen(false)}
            aria-label="Hide publish actions"
          >
            <RightArrowIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertyPostJourneyConfiguration;
